module.exports = __webpack_public_path__ + "static/media/clinician-cover-hillside.57d6553d.svg";